import {
	SET_UNPAID_INVOICES,
	SET_ACCOUNTS_PAYABLE_VENDORS,
	SET_ACCOUNTS_PAYABLE_INVOICES,
	SET_ACCOUNTS_PAYABLE_SCHEDULES,
	SET_ACCOUNTS_PAYABLE_VENDORS_BY_NUMBER,
	SET_ACCOUNTS_PAYABLE_VENDORS_BY_NAME,
	SET_UNPAID_QUEUED_INVOICES,
	SET_BANK_ACCOUNTS,
	SET_POSTED_INVOICE_RESULT,
	SET_PAYMENT_SELECTION,
	UPDATE_PAYMENT_SELECTIONALL,
	UPDATE_PAYMENT_SELECTION,
	SAVE_UNPAID_QUEUED_INVOICES,
	SAVE_UNPAID_BULK_QUEUED_INVOICES,
	REMOVE_UNPAID_FROM_QUEUED_INVOICES,
	SET_PRINT_ROWKEY,
	SET_PRINT_BATCHNUMBER_URL,
	UPDATE_ACCOUNTS_PAYABLE_PAYMENT_FILTERS,
	UPDATE_ACCOUNTS_PAYABLE_RECONCILE_FILTERS,
	SET_UNPAID_INVOICES_COUNTS,
	SET_UNPAID_INVOICES_LOADED,
	LOCK_VENDORS_FOR_PROCESSING,
	RELEASE_VENDORS_FOR_PROCESSING,
	SET_POSTING_MONTH_OPTIONS,
	SET_VENDOR_SUMMARIES,
	SORT_VENDOR_SUMMARIES,
	UPDATE_VENDOR_SUMMARIES,
	UPDATE_VENDOR_SUMMARY_PROP,
	SET_REFERENCE_NUMBERS,
	CLEAR_REFERENCE_NUMBERS,
	SET_PAYMENT_METHODS,
	SET_PAYMENT_METHODS_ENABLED
} from './accounts-payable-mutation-types';
import api from '@/services/api-service';
import accessWebApi from '@/services/accessweb-api-service';
import buildRoute from '@/composables/build-route';
import { invoicesQueuedValues } from './process-payments/invoices-queued-values';
import store from '@/store/index.js';
import router from '@/router/index.js';
import { cloneDeep, orderBy } from 'lodash';
import { PaymentMethodTypes } from '@/constants/paymentMethodsTypes.js';

export default {
	strict: process.env.NODE_ENV !== 'production',
	name: 'accountsPayable',
	namespaced: true,
	state: {
		unpaidInvoicesResults: {},
		accountsPayableVendors: {},
		accountsPayableInvoices: {},
		accountsPayableSchedules: {},
		accountsPayableVendorsByNumber: {},
		accountsPayableVendorsByName: {},
		unpaidQueuedInvoicesResults: {},
		bankAccounts: {},
		postedInvoiceResult: [],
		accountsPayableReconcileFilters: {},
		accountsPayablePaymentFilters: {},
		paymentSelection: [],
		printRowKey: '',
		printBatchNumberUrl: '',
		unpaidInvoicesCounts: {},
		unpaidInvoicesLoaded: false,
		lockedVendorIds: [],
		userWithLock: undefined,
		paymentsProcessing: false,
		postingMonthOptions: {},
		unpaidInvoicesVendorSummaries: [],
		unpaidQueuedInvoicesVendorSummaries: [],
		referenceNumbers: {},
		paymentMethods: {},
		paymentMethodsEnabled: false
	},
	mutations: {
		[UPDATE_VENDOR_SUMMARY_PROP](
			state,
			{ queued, vendorId, propertyName, value }
		) {
			let vendorSummaries;
			let vendorItem;

			if (queued) {
				vendorSummaries = state.unpaidQueuedInvoicesVendorSummaries;
			} else {
				vendorSummaries = state.unpaidInvoicesVendorSummaries;
			}

			vendorItem = vendorSummaries.find(v => v.vendorId === vendorId);

			if (vendorItem) {
				vendorItem[propertyName] = value;
			}
		},
		[SET_VENDOR_SUMMARIES](state, { queued }) {
			let vendorSummaries = [];
			let unpaidInvoices = [];
			let results;

			if (queued) {
				results = state.unpaidQueuedInvoicesResults;
			} else {
				results = state.unpaidInvoicesResults;
			}
			if (results && results.items) {
				unpaidInvoices.push(...results.items);
			}

			while (unpaidInvoices.length > 0) {
				let paymentMethod;
				let paymentMethodType;

				let nextItem = unpaidInvoices.shift();
				let vendorItem = vendorSummaries.find(
					v => v.vendorId === nextItem.vendorId
				);

				if (
					state.paymentMethodsEnabled &&
					state.paymentMethods?.items?.length > 0
				) {
					paymentMethod = state.paymentMethods.items.find(pm =>
						nextItem.bankAccountPaymentMethodsId
							? pm.id == nextItem.bankAccountPaymentMethodsId
							: pm.default
					);

					paymentMethodType = PaymentMethodTypes.find(
						p => p.id == paymentMethod?.paymentMethodTypesId
					);
				}

				nextItem.invoiceNetTotal = nextItem.amount + nextItem.discount;

				if (vendorItem) {
					vendorItem.childRecordset.push(nextItem);
				} else {
					vendorItem = {
						vendorId: nextItem.vendorId,
						vendorName: nextItem.vendorName,
						vendorNumber: nextItem.vendorNumber,
						paymentType: state.paymentMethodsEnabled
							? paymentMethodType?.description
							: 'Check',
						childRecordset: [nextItem]
					};

					vendorSummaries.push(vendorItem);
				}
			}

			if (queued) {
				state.unpaidQueuedInvoicesVendorSummaries = vendorSummaries;
			} else {
				state.unpaidInvoicesVendorSummaries = vendorSummaries;
			}
		},
		[UPDATE_VENDOR_SUMMARIES](state) {
			let invoices;
			let summaries;
			const queuedOpts = [true, false];

			queuedOpts.forEach(queued => {
				if (queued) {
					invoices = state.unpaidQueuedInvoicesResults.items;
					summaries = state.unpaidQueuedInvoicesVendorSummaries;
				} else {
					invoices = state.unpaidInvoicesResults.items;
					summaries = state.unpaidInvoicesVendorSummaries;
				}

				//remove summaries that have no queued items
				if (queued) {
					summaries = summaries.filter(summary => {
						//remove invoices that aren't queued
						summary.childRecordset = summary.childRecordset.filter(
							item => invoices.find(i => i.id === item.id)
						);

						return summary.childRecordset.length > 0;
					});
				}

				summaries.forEach(summary => {
					let paymentMethod;
					let vendorPaymentInfo = state.paymentSelection.find(
						item => item.vendorId === summary.vendorId
					);
					let vendorLocked;

					if (
						state.lockedVendorIds &&
						state.lockedVendorIds.indexOf(summary.vendorId) >= 0
					) {
						vendorLocked = true;
					}

					if (
						state.paymentMethodsEnabled &&
						state.paymentMethods?.items
					) {
						paymentMethod = state.paymentMethods.items.find(ba =>
							vendorPaymentInfo?.bankAccountPaymentMethodsId
								? ba.id ==
								  vendorPaymentInfo.bankAccountPaymentMethodsId
								: ba.default
						);
					}

					summary.queuedTotal = 0;
					summary.discountApplied = 0;
					summary.selected = vendorPaymentInfo
						? vendorPaymentInfo.selected
						: false;
					summary.bankAccount = vendorPaymentInfo
						? vendorPaymentInfo.bankAccount
						: undefined;

					if (state.paymentMethodsEnabled) {
						summary.bankAccountPaymentMethodsId = vendorPaymentInfo
							? paymentMethod?.id
							: undefined;
						summary.paymentMethod = vendorPaymentInfo
							? paymentMethod
							: undefined;

						summary.paymentMethodDescription = vendorPaymentInfo
							? paymentMethod?.description
							: undefined;
					}

					summary.for = vendorPaymentInfo
						? vendorPaymentInfo.for
						: undefined;
					summary.description = vendorPaymentInfo
						? vendorPaymentInfo.description
						: undefined;

					summary.childRecordset.forEach(summaryInvoice => {
						const resultsInvoice = invoices.find(
							i => i.id === summaryInvoice.id
						);

						if (resultsInvoice) {
							summaryInvoice.queued = resultsInvoice.queued;

							summary.queuedTotal += summaryInvoice.queued
								? summaryInvoice.amount +
								  summaryInvoice.discount
								: 0;

							summary.queuedTotal = parseFloat(
								summary.queuedTotal.toFixed(2)
							);

							summary.discountApplied += summaryInvoice.queued
								? summaryInvoice.discount
								: 0;
						}
					});

					if (queued) {
						summary.paymentDetails = summary.childRecordset.filter(
							x => x.queued
						).length;
					}
					let isPaymentMethodOrBankAccountEmpty = () => {
						if (state.paymentMethodsEnabled) {
							return !vendorPaymentInfo.bankAccountPaymentMethodsId;
						} else {
							return !vendorPaymentInfo.bankAccount;
						}
					};

					summary.disabled =
						vendorLocked ||
						!vendorPaymentInfo ||
						isPaymentMethodOrBankAccountEmpty() ||
						summary.queuedTotal < 0;
					summary.onHold = summary.childRecordset.some(
						i => i.onHold === true
					);

					if (summary.childRecordset.every(v => v.queued)) {
						summary.invoicesQueued = invoicesQueuedValues.all;
					} else if (summary.childRecordset.every(v => !v.queued)) {
						summary.invoicesQueued = invoicesQueuedValues.none;
					} else {
						summary.invoicesQueued = invoicesQueuedValues.some;
					}
				});

				if (queued) {
					state.unpaidQueuedInvoicesVendorSummaries = summaries;
				} else {
					state.unpaidInvoicesVendorSummaries = summaries;
				}
			});
		},
		[SORT_VENDOR_SUMMARIES](state, { sortBy, queued }) {
			let vendorSummaries = [];
			let sortColumn;
			let sortDirection;
			let sortArr;

			if (sortBy) {
				sortArr = sortBy.split(' ');

				if (sortArr.length === 2) {
					if (queued) {
						vendorSummaries =
							state.unpaidQueuedInvoicesVendorSummaries;
					} else {
						vendorSummaries = state.unpaidInvoicesVendorSummaries;
					}

					sortColumn = sortArr[0];
					sortDirection = sortArr[1];

					vendorSummaries = orderBy(
						vendorSummaries,
						sortColumn,
						sortDirection
					);

					if (queued) {
						state.unpaidQueuedInvoicesVendorSummaries = vendorSummaries;
					} else {
						state.unpaidInvoicesVendorSummaries = vendorSummaries;
					}
				}
			}
		},
		[SET_UNPAID_INVOICES_COUNTS](state, unpaidInvoices) {
			let counts = {
				vendors: [],
				vendorCount: 0,
				invoiceCount: 0,
				total: 0
			};

			if (unpaidInvoices && unpaidInvoices.items) {
				counts = unpaidInvoices.items.reduce((acc, invoice) => {
					const vendorId = invoice.vendorId;

					if (acc.vendors.indexOf(vendorId) < 0) {
						acc.vendors.push(vendorId);
					}

					acc.total += invoice.amount;

					return acc;
				}, counts);

				counts.vendorCount = counts.vendors.length;
				counts.invoiceCount = unpaidInvoices.items.length;
			}

			state.unpaidInvoicesCounts = counts;
		},
		[SET_UNPAID_INVOICES](
			state,
			{ unpaidInvoices, companyId, parameters }
		) {
			state.unpaidInvoicesResults = unpaidInvoices;

			state.accountsPayableReconcileFilters = {
				companyId: companyId,
				parameters: cloneDeep(parameters)
			};
		},
		[SET_UNPAID_INVOICES_LOADED](state, unpaidInvoicesLoaded) {
			state.unpaidInvoicesLoaded = unpaidInvoicesLoaded;
		},
		[SET_ACCOUNTS_PAYABLE_VENDORS](state, accountsPayableVendors) {
			state.accountsPayableVendors = accountsPayableVendors;
		},
		[SET_ACCOUNTS_PAYABLE_VENDORS_BY_NUMBER](
			state,
			accountsPayableVendors
		) {
			state.accountsPayableVendorsByNumber = accountsPayableVendors;
		},
		[SET_ACCOUNTS_PAYABLE_VENDORS_BY_NAME](state, accountsPayableVendors) {
			state.accountsPayableVendorsByName = accountsPayableVendors;
		},
		[SET_ACCOUNTS_PAYABLE_INVOICES](state, accountsPayableInvoices) {
			state.accountsPayableInvoices = accountsPayableInvoices;
		},
		[SET_ACCOUNTS_PAYABLE_SCHEDULES](state, accountsPayableSchedules) {
			state.accountsPayableSchedules = accountsPayableSchedules;
		},
		[SET_UNPAID_QUEUED_INVOICES](state, { unpaidInvoices }) {
			state.unpaidQueuedInvoicesResults = unpaidInvoices;
		},
		[SET_BANK_ACCOUNTS](state, bankAccounts) {
			state.bankAccounts = bankAccounts;
		},
		[SET_POSTED_INVOICE_RESULT](
			state,
			{ postedInvoiceResult, flushState }
		) {
			if (flushState) {
				//Initialize the list of responses
				state.postedInvoiceResult = [];
			}

			if (state.paymentMethodsEnabled) {
				//match postedInvoiceResult.data.VendorId to the vendorId in the unpaidQueuedInvoicesVendorSummaries then write that items bankAccountPaymentMethodsId to the postedInvoiceResult
				const vendorSummary = state.unpaidQueuedInvoicesVendorSummaries.find(
					v => v.vendorId === postedInvoiceResult.data.VendorId
				);
				if (vendorSummary) {
					postedInvoiceResult.data.paymentMethodTypesId =
						vendorSummary.paymentMethod?.paymentMethodTypesId;
				}
			}
			//Include the response to the list
			state.postedInvoiceResult.push(postedInvoiceResult);
		},
		[UPDATE_PAYMENT_SELECTIONALL](state, { vendorIds, selectAll }) {
			if (!vendorIds) vendorIds = [];

			state.paymentSelection.filter(v => {
				if (vendorIds.includes(v.vendorId)) {
					v.selected = selectAll;
				}
			});
		},
		[SET_PAYMENT_SELECTION](state) {
			let defaultBankAccount;
			let defaultPaymentMethod;

			if (state.bankAccounts && state.bankAccounts.items) {
				defaultBankAccount = state.bankAccounts.items.find(
					ba => ba.defaultAccount
				);
			}

			if (state.paymentMethods && state.paymentMethods.items) {
				defaultPaymentMethod = state.paymentMethods.items.find(
					ba => ba.default
				);
			}

			state.paymentSelection = [];
			state.unpaidQueuedInvoicesVendorSummaries.filter(vendor => {
				let vendorBankAccount = vendor.bankAccount;

				let vendorChildRecordset = vendor.childRecordset.find(
					v => v.vendorId == vendor.vendorId
				);

				if (!vendorBankAccount && defaultBankAccount) {
					vendorBankAccount = defaultBankAccount.id;
				}

				state.paymentSelection.push({
					vendorId: vendor.vendorId,
					bankAccount: vendorBankAccount,
					bankAccountPaymentMethodsId:
						vendorChildRecordset.bankAccountPaymentMethodsId ||
						defaultPaymentMethod?.id,
					for: vendor.for,
					description: vendor.description,
					selected: vendor.selected
				});
			});
		},
		[UPDATE_PAYMENT_SELECTION](state, { value, vendorId, propertyName }) {
			state.paymentSelection.find(v => {
				if (v.vendorId === vendorId) v[propertyName] = value;
			});
		},
		[SAVE_UNPAID_QUEUED_INVOICES](
			state,
			{ accountsPayableIds, queueValue }
		) {
			accountsPayableIds.filter(id => {
				state.unpaidInvoicesResults.items.filter(item => {
					if (item.id == id) {
						item.queued = queueValue;
					}
				});

				state.unpaidQueuedInvoicesResults.items = state.unpaidInvoicesResults.items.filter(
					item => item.queued === true
				);
			});
		},
		[REMOVE_UNPAID_FROM_QUEUED_INVOICES](
			state,
			{ accountsPayableIds, queueValue }
		) {
			accountsPayableIds.filter(id => {
				state.unpaidInvoicesResults.items.filter(item => {
					if (item.id == id) {
						item.queued = queueValue;
					}
				});

				let index = state.unpaidQueuedInvoicesResults.items.findIndex(
					i => i.id === id
				);
				state.unpaidQueuedInvoicesResults.items.splice(index, 1);
			});

			// state.unpaidQueuedInvoicesResults.items = state.unpaidQueuedInvoicesResults.items.filter(
			// 	item => item.queued === true
			// );
		},
		[SAVE_UNPAID_BULK_QUEUED_INVOICES](
			state,
			{ vendorIds, queueValue, dueDate }
		) {
			let checkDueDate;
			let checkVendorIds;

			if (dueDate !== undefined && dueDate !== null) {
				checkDueDate = new Date(dueDate);
			}

			if (
				vendorIds !== undefined &&
				vendorIds !== null &&
				vendorIds.length > 0
			) {
				checkVendorIds = vendorIds;
			}

			state.unpaidInvoicesResults.items.filter(item => {
				if (
					(checkVendorIds == undefined ||
						checkVendorIds.indexOf(item.vendorId) >= 0) &&
					(checkDueDate === undefined ||
						new Date(item.dueDate) <= checkDueDate)
				) {
					item.queued = queueValue;
				}
			});
		},
		[UPDATE_ACCOUNTS_PAYABLE_PAYMENT_FILTERS](state, parameters) {
			const currentFilters =
				state.accountsPayablePaymentFilters.parameters;
			const newFilters = {
				...currentFilters,
				...parameters
			};

			state.accountsPayablePaymentFilters = {
				companyId: state.accountsPayablePaymentFilters.companyId,
				parameters: cloneDeep(newFilters)
			};
		},
		[UPDATE_ACCOUNTS_PAYABLE_RECONCILE_FILTERS](state, parameters) {
			const currentFilters =
				state.accountsPayableReconcileFilters.parameters;
			const newFilters = {
				...currentFilters,
				...parameters
			};

			state.accountsPayableReconcileFilters = {
				companyId: state.accountsPayableReconcileFilters.companyId,
				parameters: cloneDeep(newFilters)
			};
		},
		[SET_PRINT_BATCHNUMBER_URL](state, printBatchNumberUrl) {
			state.printBatchNumberUrl = printBatchNumberUrl;
		},
		[SET_PRINT_ROWKEY](state, printRowKey) {
			state.printRowKey = printRowKey;
		},
		/**
		 *
		 * @param {*} state
		 * @param { * } data { user, vendorIds }
		 */
		[LOCK_VENDORS_FOR_PROCESSING](state, data) {
			state.lockedVendorIds = data.vendorIds;
			state.userWithLock = data.user;
			state.paymentsProcessing = true;
		},
		[RELEASE_VENDORS_FOR_PROCESSING](state) {
			state.lockedVendorIds = [];
			state.userWithLock = undefined;
			state.paymentsProcessing = false;
		},
		[SET_POSTING_MONTH_OPTIONS](state, postingMonthOptions) {
			state.postingMonthOptions = postingMonthOptions;
		},
		[SET_REFERENCE_NUMBERS](state, referenceNumbers) {
			state.referenceNumbers = referenceNumbers;
		},
		[CLEAR_REFERENCE_NUMBERS](state) {
			state.referenceNumbers = {};
		},
		[SET_PAYMENT_METHODS](state, paymentMethods) {
			state.paymentMethods = paymentMethods;
		},
		[SET_PAYMENT_METHODS_ENABLED](state, value) {
			state.paymentMethodsEnabled = value;
		}
	},
	actions: {
		// actions let us get to ({ state, getters, commit, dispatch }) {
		updateVendorSummaryPropAction(
			{ commit },
			{ queued, vendorId, propertyName, value }
		) {
			commit(UPDATE_VENDOR_SUMMARY_PROP, {
				queued,
				vendorId,
				propertyName,
				value
			});

			commit(UPDATE_VENDOR_SUMMARIES);
		},
		setVendorSummariesAction({ commit }, { sortBy, queued }) {
			commit(SET_VENDOR_SUMMARIES, { queued });

			commit(UPDATE_VENDOR_SUMMARIES);

			commit(SORT_VENDOR_SUMMARIES, {
				sortBy: sortBy,
				queued: queued
			});
		},
		async getUnpaidInvoicesCountsAction(
			{ commit },
			{ companyId, parameters }
		) {
			const unpaidInvoices = await api.get(
				buildRoute(
					'/accounting/company/{companyId}/accountspayable/unpaid',
					{
						companyId: companyId,
						query: parameters
					}
				)
			);
			commit(SET_UNPAID_INVOICES_COUNTS, unpaidInvoices);
		},
		resetUnpaidInvoicesCountsAction({ commit }) {
			commit(SET_UNPAID_INVOICES_COUNTS, {});
		},
		async getUnpaidInvoicesAction(
			{ commit, dispatch },
			{ companyId, parameters }
		) {
			const unpaidInvoices = await api.get(
				buildRoute(
					'/accounting/company/{companyId}/accountspayable/unpaid',
					{
						companyId: companyId,
						query: parameters
					}
				)
			);

			if (parameters.queued) {
				commit(SET_UNPAID_QUEUED_INVOICES, {
					unpaidInvoices,
					companyId,
					parameters
				});
			} else {
				commit(SET_UNPAID_INVOICES, {
					unpaidInvoices,
					companyId,
					parameters
				});
			}

			commit(SET_VENDOR_SUMMARIES, {
				queued: parameters.queued
			});

			if (parameters.queued) {
				dispatch('setPaymentSelection');
			}

			commit(UPDATE_VENDOR_SUMMARIES);

			commit(SORT_VENDOR_SUMMARIES, {
				sortBy: parameters.sortBy,
				queued: parameters.queued
			});

			commit(SET_UNPAID_INVOICES_LOADED, true);
		},
		async getAccountsPayableVendorsAction(
			{ commit },
			{ companyId, parameters }
		) {
			const accountsPayableVendors = await api.get(
				buildRoute(
					'/accounting/company/{companyId}/accountspayable/vendors',
					{
						companyId: companyId,
						query: parameters
					}
				)
			);

			commit(SET_ACCOUNTS_PAYABLE_VENDORS, accountsPayableVendors);
		},
		async getAccountsPayableVendorsByNumberAction(
			{ commit },
			{ companyId, parameters }
		) {
			const accountsPayableVendors = await api.get(
				buildRoute(
					'/accounting/company/{companyId}/accountspayable/vendors',
					{
						companyId: companyId,
						query: parameters
					}
				)
			);

			commit(
				SET_ACCOUNTS_PAYABLE_VENDORS_BY_NUMBER,
				accountsPayableVendors
			);
		},
		async getAccountsPayableVendorsByNameAction(
			{ commit },
			{ companyId, parameters }
		) {
			const accountsPayableVendors = await api.get(
				buildRoute(
					'/accounting/company/{companyId}/accountspayable/vendors',
					{
						companyId: companyId,
						query: parameters
					}
				)
			);

			commit(
				SET_ACCOUNTS_PAYABLE_VENDORS_BY_NAME,
				accountsPayableVendors
			);
		},
		async getAccountsPayableInvoicesAction(
			{ commit },
			{ companyId, parameters }
		) {
			const accountsPayableInvoices = await api.get(
				buildRoute(
					'/accounting/company/{companyId}/accountspayable/invoices',
					{
						companyId: companyId,
						query: parameters
					}
				)
			);

			commit(SET_ACCOUNTS_PAYABLE_INVOICES, accountsPayableInvoices);
		},
		async getAccountsPayableSchedulesAction(
			{ commit },
			{ companyId, parameters }
		) {
			const accountsPayableSchedules = await api.get(
				buildRoute(
					'/accounting/company/{companyId}/accountspayable/schedules',
					{
						companyId: companyId,
						query: parameters
					}
				)
			);

			commit(SET_ACCOUNTS_PAYABLE_SCHEDULES, accountsPayableSchedules);
		},
		async getBankAccountsAction({ commit }, { companyId, parameters }) {
			const bankAccounts = await api.get(
				buildRoute(
					'/accounting/company/{companyId}/accountspayable/bankaccounts',
					{
						companyId: companyId,
						query: parameters
					}
				)
			);

			commit(SET_BANK_ACCOUNTS, bankAccounts);
		},
		async postQueuedInvoice(
			{ commit, state },
			{ parameters, model, flushState }
		) {
			var postedInvoiceResult = {};

			try {
				postedInvoiceResult = await accessWebApi.post(
					buildRoute(
						'/integration/{dealerguid}/{dealerNumber}/{companyId}/postapchecks',
						{
							dealerguid: parameters.dealerGuid,
							dealerNumber: parameters.dealerNumber,
							companyId: parameters.companyId
						}
					),
					{
						InvoiceIds: [...model.InvoiceIds],
						BankAccountId: model.BankAccountId,
						For: model.For,
						Description: model.Description,
						PostAhead: model.PostAhead,
						ReferenceNumber: model.ReferenceNumber,
						bankAccountPaymentMethodsId:
							model.bankAccountPaymentMethodsId
					}
				);
			} catch (e) {
				//If the API call fail, include the error in the posting response list
				postedInvoiceResult = {
					success: false,
					reason: 'FAILED API CALL',
					data: {
						HTMLString: 'Internal Server Error<br>',
						VendorNumber: model.VendorNumber,
						vendorId: model.VendorId
					}
				};
			}

			if (state.paymentMethodsEnabled) {
				postedInvoiceResult.data.bankAccountPaymentMethodsId =
					model.bankAccountPaymentMethodsId;
			}

			commit(SET_POSTED_INVOICE_RESULT, {
				postedInvoiceResult,
				flushState
			});
		},
		setPaymentSelection({ commit }) {
			commit(SET_PAYMENT_SELECTION);
		},
		setPaymentMethodsEnabled({ commit }, value) {
			commit(SET_PAYMENT_METHODS_ENABLED, value);
		},
		async updatePaymentSelection(
			{ commit },
			{ value, vendorId, propertyName }
		) {
			commit(UPDATE_PAYMENT_SELECTION, { value, vendorId, propertyName });
		},
		async updatePaymentSelectionAll({ commit }, { vendorIds, selectAll }) {
			commit(UPDATE_PAYMENT_SELECTIONALL, { vendorIds, selectAll });
			commit(UPDATE_VENDOR_SUMMARIES);
		},
		async removeInvoicesFromQueueAction(
			{ commit, getters },
			{ companyId, parameters }
		) {
			const queueUnpaidInvoices = await api.post(
				buildRoute(
					'/accounting/company/{companyId}/accountspayable/queue',
					{
						companyId: companyId
					}
				),
				{
					accountsPayableIds: parameters.accountsPayableIds,
					queueValue: parameters.queueValue
				}
			);

			//action that sends updates to signalR
			//group name is the current path because updates go to others on the same page
			store.dispatch('hub/invokeHubMethodAction', {
				message: {
					groupName: getters.hubMethodRoute,
					mutations: [
						`accountsPayable/${REMOVE_UNPAID_FROM_QUEUED_INVOICES}`,
						`accountsPayable/${UPDATE_VENDOR_SUMMARIES}`
					],
					data: parameters
				}
			});

			if (queueUnpaidInvoices.successFlag) {
				commit(REMOVE_UNPAID_FROM_QUEUED_INVOICES, parameters);
				commit(UPDATE_VENDOR_SUMMARIES);
			}
		},
		async saveInvoicestoQueueAction(
			{ commit, getters },
			{ companyId, parameters }
		) {
			const queueUnpaidInvoices = await api.post(
				buildRoute(
					'/accounting/company/{companyId}/accountspayable/queue',
					{
						companyId: companyId
					}
				),
				{
					accountsPayableIds: parameters.accountsPayableIds,
					queueValue: parameters.queueValue
				}
			);

			//action that sends updates to signalR
			//group name is the current path because updates go to others on the same page
			store.dispatch('hub/invokeHubMethodAction', {
				message: {
					groupName: getters.hubMethodRoute,
					mutations: [
						`accountsPayable/${SAVE_UNPAID_QUEUED_INVOICES}`,
						`accountsPayable/${UPDATE_VENDOR_SUMMARIES}`
					],
					data: parameters
				}
			});

			if (queueUnpaidInvoices.successFlag) {
				commit(SAVE_UNPAID_QUEUED_INVOICES, parameters);
				commit(UPDATE_VENDOR_SUMMARIES);
			}
		},
		async saveInvoicestoBulkQueueAction(
			{ commit, getters },
			{ companyId, parameters }
		) {
			const bulkQueueUnpaidInvoices = await api.post(
				buildRoute(
					'/accounting/company/{companyId}/accountspayable/bulk-queue',
					{
						companyId: companyId
					}
				),
				parameters
			);

			//action that sends updates to signalR
			//group name is the current path because updates go to others on the same page
			store.dispatch('hub/invokeHubMethodAction', {
				message: {
					groupName: getters.hubMethodRoute,
					mutations: [
						`accountsPayable/${SAVE_UNPAID_BULK_QUEUED_INVOICES}`,
						`accountsPayable/${UPDATE_VENDOR_SUMMARIES}`
					],
					data: parameters
				}
			});

			if (bulkQueueUnpaidInvoices.successFlag) {
				commit(SAVE_UNPAID_BULK_QUEUED_INVOICES, parameters);
				commit(UPDATE_VENDOR_SUMMARIES);
			}
		},
		async getPrintBatchNumberUrl({ commit }, { parameters, model }) {
			const printBatchNumberUrl = await accessWebApi.post(
				buildRoute(
					'/integration/{dealerguid}/{dealerNumber}/{companyId}/printapbatchnumbers',
					{
						dealerguid: parameters.dealerGuid,
						dealerNumber: parameters.dealerNumber,
						companyId: parameters.companyId
					}
				),
				{
					FileName: model.FileName,
					BatchList: [...model.BatchList],
					GridColumns: [...model.GridColumns]
				}
			);

			commit(SET_PRINT_BATCHNUMBER_URL, printBatchNumberUrl);
		},
		async updateAccountsPayablePaymentFilters({ commit }, parameters) {
			commit(UPDATE_ACCOUNTS_PAYABLE_PAYMENT_FILTERS, parameters);
		},
		async updateAccountsPayableReconcileFiltersAction(
			{ commit },
			parameters
		) {
			commit(UPDATE_ACCOUNTS_PAYABLE_RECONCILE_FILTERS, parameters);
		},
		async getPrintRowKey(
			{ commit },
			{ parameters, multiplePrintingModel }
		) {
			const printRowKey = await accessWebApi.post(
				buildRoute(
					'/integration/{dealerguid}/{dealerNumber}/{companyId}/printchecks',
					{
						dealerguid: parameters.dealerGuid,
						dealerNumber: parameters.dealerNumber,
						companyId: parameters.companyId
					}
				),
				[...multiplePrintingModel]
			);

			commit(SET_PRINT_ROWKEY, printRowKey);
		},
		async lockVendorsForProcessingAction(
			// eslint-disable-next-line no-unused-vars
			{ commit, getters },
			{ user, vendorIds, expirationSeconds }
		) {
			const data = { user: cloneDeep(user), vendorIds: vendorIds };
			await store.dispatch('hub/invokeHubMethodAction', {
				message: {
					mutations: [
						`accountsPayable/${LOCK_VENDORS_FOR_PROCESSING}`
					],
					groupName: getters.hubMethodRoute,
					data: data,
					dealershipGroupId: user.AspNetCompaniesId,
					companyId: user.CurrentEmployeeCompanyId,
					serverAction: 'Persist',
					persistExpirationSeconds: expirationSeconds,
					persistKey: getters.hubMethodRoute
				}
			});
		},
		// eslint-disable-next-line no-unused-vars
		releaseVendorsForProcessingAction({ commit, getters }, user) {
			const data = { user: cloneDeep(user) };

			store.dispatch('hub/invokeHubMethodAction', {
				message: {
					mutations: [
						`accountsPayable/${RELEASE_VENDORS_FOR_PROCESSING}`
					],
					groupName: getters.hubMethodRoute,
					data: data,
					dealershipGroupId: user.AspNetCompaniesId,
					companyId: user.CurrentEmployeeCompanyId,
					serverAction: 'Remove',
					persistKey: getters.hubMethodRoute
				}
			});
		},
		// eslint-disable-next-line no-unused-vars
		async getLockedVendorsAction({ commit, getters }, user) {
			await store.dispatch('hub/invokeHubMethodAction', {
				message: {
					mutations: [
						`accountsPayable/${LOCK_VENDORS_FOR_PROCESSING}`
					],
					dealershipGroupId: user.AspNetCompaniesId,
					companyId: user.CurrentEmployeeCompanyId,
					persistKey: getters.hubMethodRoute
				},
				method: 'GetCommunication'
			});
		},
		async getPostingMonthOptionsAction({ commit }, companyId) {
			const postingMonthOptions = await api.get(
				buildRoute(
					'/accounting/company/{companyId}/accountspayable/postingmonthoptions',
					{
						companyId: companyId
					}
				)
			);

			commit(SET_POSTING_MONTH_OPTIONS, postingMonthOptions);
		},
		setReferenceNumbersAction({ commit }, referenceNumbers) {
			commit(SET_REFERENCE_NUMBERS, referenceNumbers);
		},
		clearReferenceNumbersAction({ commit }) {
			commit(CLEAR_REFERENCE_NUMBERS);
		},
		async getPaymentMethodsAction({ commit }, companyId) {
			const paymentMethodsOptions = await api.get(
				buildRoute(
					'/accounting/company/{companyId}/accountspayable/paymentmethods',
					{
						companyId: companyId
					}
				)
			);

			commit(SET_PAYMENT_METHODS, paymentMethodsOptions);
		}
	},
	getters: {
		paymentsProcessing: state => state.paymentsProcessing,
		lockedVendorIds: state => state.lockedVendorIds,
		userWithLock: state => state.userWithLock,
		userWithLockName: state => {
			let name;

			if (state.userWithLock) {
				name = `${state.userWithLock.FirstName} ${state.userWithLock.LastName}`;
			}

			return name;
		},
		postingMonthOptions: state => state.postingMonthOptions,
		twoPeriodOpen: state => {
			let result = false;

			if (state.postingMonthOptions) {
				result = state.postingMonthOptions.twoPeriodOpen;
			}

			return result;
		},
		unpaidInvoicesCounts: state => state.unpaidInvoicesCounts,
		unpaidInvoicesResults: state => state.unpaidInvoicesResults,
		unpaidQueuedInvoicesResults: state => state.unpaidQueuedInvoicesResults,
		accountsPayableVendors: state => state.accountsPayableVendors,
		paymentSelection: state => state.paymentSelection,
		postedInvoiceResult: state => state.postedInvoiceResult,
		accountsPayableVendorsByNumber: state =>
			state.accountsPayableVendorsByNumber,
		accountsPayableInvoices: state => state.accountsPayableInvoices,
		accountsPayableSchedules: state => state.accountsPayableSchedules,
		bankAccounts: state => state.bankAccounts,
		accountsPayableReconcileFilters: state =>
			state.accountsPayableReconcileFilters,
		accountsPayablePaymentFilters: state =>
			state.accountsPayablePaymentFilters,
		printRowKey: state => state.printRowKey,
		printBatchNumberUrl: state => state.printBatchNumberUrl,
		unpaidInvoicesVendorSummaries: state =>
			state.unpaidInvoicesVendorSummaries,
		unpaidQueuedInvoicesVendorSummaries: state =>
			state.unpaidQueuedInvoicesVendorSummaries,
		unpaidInvoicesLoaded: state => state.unpaidInvoicesLoaded,
		vendorBankAccount: state => vendorId => {
			let vendorPaymentInfo = state.paymentSelection.find(
				item => item.vendorId === vendorId
			);

			return vendorPaymentInfo
				? vendorPaymentInfo.bankAccount
				: undefined;
		},
		referenceNumbers: state => state.referenceNumbers,
		paymentMethods: state => state.paymentMethods,
		vendorPaymentMethod: state => vendorId => {
			let vendorPaymentMethod = state.paymentSelection.find(
				item => item.vendorId === vendorId
			);

			return vendorPaymentMethod
				? vendorPaymentMethod.bankAccountPaymentMethodsId
				: undefined;
		},
		paymentMethodsEnabled: state => state.paymentMethodsEnabled,
		hubMethodRoute: () => {
			let companyId = router.currentRoute.params.companyid;

			return (
				'/company/' +
				companyId +
				'/accounting/accountspayable/processpayments'
			);
		}
	}
};
